// Ein einzelnes Bit: Läuft gerade ein Übungs-Kapitel der Tour?
//
// Das Erfassungs-Kapitel führt durch das echte Formular — der neue
// Mitarbeiter klickt dieselben Knöpfe wie im Alltag. Die dabei
// entstehende Bestellung muss aber als Übung markiert werden, sonst
// steht sie danach als echte auf dem Brett.
//
// Bewusst ein Modul-Wert und kein Context: das Formular soll deswegen
// nicht in einen Provider eingehängt werden müssen, und die Frage ist
// wirklich global — es gibt nur eine laufende Tour.

let aktiv = false;

export function setzeUebungsModus(an: boolean): void {
  aktiv = an;
}

export function istUebungsModus(): boolean {
  return aktiv;
}
